import React from 'react'
import {
    Box,
    Button,
} from '@material-ui/core'
import { useSelector } from 'react-redux'
import { SideBar } from '../../../components/side-bar'
import { navLinksOrganization } from '../../../services'
import { Link } from 'react-router-dom'
import { DataTable } from '../../../components/dataTable'
import { ROUTES } from '../../../constants'
import { IProvider } from '../../../store/types'
import { providers } from '../../../store/slices/provider'
import { FetchCollectionParams, FetchCreatedAtParams } from '../../../services/_common'

export function ProvidersPage(): JSX.Element {

    const fetchStatus = useSelector(providers.selectors.fetchStatus)
    const totalItems = useSelector(providers.selectors.totalItems)

    return (
        <Box display="flex">
            <SideBar navLinks={navLinksOrganization}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    component={Link}
                    to={ROUTES.ORGANIZATION_PROVIDERS_CREATE}
                >
                    Создать
                </Button>
            </SideBar>
            <DataTable<IProvider, FetchCreatedAtParams & FetchCollectionParams>
                title={'Поставщики'}
                urlPathEdit={'/organization/providers/edit'}
                fetchProps={{
                    page: 1,
                    perPage: 20,
                }}
                fetchAction={providers.actions.fetch}
                deleteAction={providers.actions.remove}
                selector={providers.selectors.selectAll}
                mappingFunction={(provider) => ({
                    id: provider.id,
                    name: provider.name,
                })}
                columns={[
                    { field: 'id', headerName: 'ID', flex: 1, hide: true },
                    { field: 'name', headerName: 'Название', flex: 1 },
                ]}
                loading={fetchStatus.isFetching}
                rowCount={totalItems}
            >
            </DataTable>
        </Box>
    )
}